function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173,
    height: 173,
    viewBox: "0 0 173 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(-188 -167)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 86.5,
    cy: 86.5,
    r: 86.5,
    transform: "translate(188 167)",
    style: {
      fill: "rgba(204, 204, 204, 0.8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M19.727,50.661V69.388L52.5,87.273,85.273,69.388V50.661L52.5,68.545ZM52.5,3,1,31.091,52.5,59.182,94.636,36.194V68.545H104V31.091Z",
    transform: "translate(221.5 208.364)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolPlaceholder);
export default __webpack_public_path__ + "static/media/school_placeholder.322588b78fe8063453e61929120bd4f8.svg";
export { ForwardRef as ReactComponent };